import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetGameTypeTableData } from '@/modules/game/type'
import GameTypeTable from '../GameTypeTable'

interface GameTypeListingProps {
	data: GetGameTypeTableData[]
}

export default function GameTypeListing({ data }: GameTypeListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`รายชื่อประเภทเกม`} description="รายชื่อประเภทเกม" />
			</div>
			<Separator />
			<GameTypeTable data={data} />
		</div>
	)
}
